module.exports = __webpack_public_path__ + "static/rewards-0899d72ba2222c5834e29b42869a679c.mp4";